var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ProductUtility } from '@inter-ikea-kompis/utilities';
import { TextToggle } from '@inter-ikea-kompis/component-text-toggle';
import EprelQr from '../eprel-qr/EprelQr.js';
/**
 * Data-driven information listing.
 *
 * @event expand Triggered when toggle is clicked
 * @event animationEnd Triggered when animation ends
 */
export default class EprelQrToggle extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated - use "translations" instead.
        this.localizedInformation = null;
        // The translations retrieved from translations service.
        this.translations = null;
        // Expanded
        this.expanded = false;
    }
    /**
     * @returns Template.
     */
    render() {
        // We want translations to be required, but since both props to provide translations are optional, this check is needed until localizedInformation is removed.
        if (!this.hasTranslations()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        const link = ProductUtility.getProductInformationSheetLink(this.product);
        if (!link) {
            return null;
        }
        return html `
			<kompis-text-toggle
				.theme="${this.theme}"
				.label="${link.text}"
				.expanded="${this.expanded}"
				@animationEnd="${(event) => this.dispatchEvent(new CustomEvent('animationEnd', { bubbles: true, detail: event.detail }))}"
				@expand="${(event) => this.dispatchEvent(new CustomEvent('expand', { bubbles: true, detail: event.detail }))}"
			>
				<kompis-eprel-qr
					.theme="${this.theme}"
					.product="${this.product}"
					.localizedInformation="${this.localizedInformation}"
					.translations="${this.translations}"
				></kompis-eprel-qr>
			</kompis-text-toggle>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-text-toggle', TextToggle);
        this.customElements.define('kompis-eprel-qr', EprelQr);
        super.connectedCallback();
    }
    hasTranslations() {
        return !!this.translations || !!this.localizedInformation?.translations;
    }
}
__decorate([
    property({ type: Object, required: true })
], EprelQrToggle.prototype, "product", void 0);
__decorate([
    property({ type: Object, required: true })
], EprelQrToggle.prototype, "theme", void 0);
__decorate([
    property({ type: Object })
], EprelQrToggle.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], EprelQrToggle.prototype, "translations", void 0);
__decorate([
    property({ type: Boolean })
], EprelQrToggle.prototype, "expanded", void 0);
//# sourceMappingURL=EprelQrToggle.js.map